export default "__VITE_ASSET__CheWGPOS__"